<template>
  <v-flex xs12 class="mb-4">
    <div class style="position: relative;">
      <div class="flex-container-space-between vertical-center-container">
        <layout-no-padding>
          <go-back></go-back>
          <page-title :routeProps="routeProps"></page-title>
        </layout-no-padding>
        <div></div>
      </div>
      <v-dialog v-model="addDialog" max-width="500px" @keydown.esc="addDialog = false">
        <v-btn fab dark :color="routeProps.color" class="overlap-fab-user" slot="activator">
          <v-icon dark>add</v-icon>
        </v-btn>
        <user-auth-class-edit @close="addDialog = false" add></user-auth-class-edit>
      </v-dialog>
      <card-divider-split></card-divider-split>
    </div>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import RouteProps from "@/services/mixins/routeProps";
import UserAuthClassEdit from "./userAuthClassEdit";
//GET RECORDS
import getUserAuthClasses from "@/services/mixins/getMasterFiles/getUserAuthClasses";
export default {
  mixins: [RouteProps, getUserAuthClasses],
  components: {
    UserAuthClassEdit
  },
  data() {
    return {
      addDialog: false,
      addUserAuthClassDialog: false,
      sortFactors: [
        {
          value: "id",
          text: "ID"
        },
        {
          value: "name",
          text: "Name"
        },
        {
          value: "details",
          text: "Details"
        },
        {
          value: "userAuthClassAuthClass.name",
          text: "Authorization"
        },
        {
          value: "updatedAt",
          text: "Updated At"
        }
      ]
    };
  },
  methods: {
    sortUserAuthClasss(path1, path2) {
      return this.userAuthClasss.sort((a, b) => {
        if (a[path] < b[path]) {
          return -1;
        } else {
          return 1;
        }
      });
    }
  },
  computed: {
    // sortBy: Store.getSet({store: 'users', prop: 'sortBy'}),
    // filterBy: Store.getSet({store: 'users', prop: 'filterBy'}),
  },
  watch: {}
};
</script>

<style scoped>
.overlap-fab-user {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>
